import React from 'react';
import './style.scss'

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import StepSurvey from '../../components/StepSurvey'
import MedalLink from '../../components/MedalsEbit-Link'

import ImgEbit from '../../assets/imagens/img-aboutUs02.66c09e19.jpg'
import ImgEbit2 from '../../assets/imagens/img-aboutUs01.e9428cae.jpg'
import Icon1 from '../../assets/imagens/icon-white-red-Benchmark.13983b35.svg'
import Icon2 from '../../assets/imagens/icon-white-red-ShoppingCart.5d86bcf3.svg'
import Icon3 from '../../assets/imagens/icon-white-red-Solving.8b7aaaec.svg'
import Icon4 from '../../assets/imagens/icon-white-red-Report.4921506a.svg'
import LTempo from '../../assets/imagens/EbitNielsen-LinhaTempo-h.0f7b7f5a.png'
import LTempoV from '../../assets/imagens/EbitNielsen-LinhaTempo-v.869fdf11.png'



function SobreNos() {
  return (
    <>
      <Menu></Menu>
      <div className="container-fluid bg-teste">
        <div className="about-ebit-text container">
          <h2>sobre nós</h2>
          <div>
            <p className="lead">A Ebit | Nielsen é a <strong>maior plataforma de opinião de consumidores do Brasil</strong> em que, varejistas cadastrados recebem medalhas (Bronze, Prata, Ouro e Diamante) de acordo com a opinião de consumidores em pesquisas de satisfação de experiências reais de compra, conforme os seguintes critérios: quantidade de pesquisas respondidas, porcentagens de entregas no prazo e probabilidade dos consumidores voltarem a comprar na loja.</p>
            <img src={ImgEbit2} alt="Banner empresa" />
          </div>
        </div>

        <div className="about-ebit-text container">
          <div>
            <img src={ImgEbit} alt="" className="img-responsive" />
            <p className="lead"><strong>A mensuração do mercado brasileiro de e-commerce também é feita pela Ebit | Nielsen</strong> por meio de indicadores de desempenho de vendas e de pesquisas de comportamento de compra do comércio eletrônico de lojas colaboradoras, usando metodologias de coleta digital de <strong> informações relevantes e estratégicas </strong>que permitem o acompanhamento das <strong>tendências do e-commerce como um todo.</strong></p>

          </div>
        </div>
      </div>

      <div className="ebit-numeros container-fluid">
        <div className="container">
          <div className="title-ebit-numeros">
            <p>Ebit | Nielsen em números</p>
          </div>

          <div className="info-ebit-numeros lead">
            <p className="lead">Pioneira em realizar pesquisas online que visam analisar  e entender o perfil e hábitos do consumidor virtual</p>
          </div>

          <div className="display-ebit-numeros">
            <div className="display-ebit-numeros__items-ebit-numero ">
              <img src={Icon1} alt="Icone barra" />
              <p className="numero-ebit">+de 10 mil</p>
              <p className="info-numeros-ebit">Pesquisas respondidas por dia</p>
            </div>

            <div className="display-ebit-numeros__items-ebit-numero">
              <img src={Icon4} alt="Icone barra" />
              <p className="numero-ebit">97 mil</p>
              <p className="info-numeros-ebit">Lojas avaliadas até <br /> o momento</p>
              <small className="form-text text-muted"><i>Lojas que já tiveram cadastro em algum momento no Ebit | Nielsen</i></small>
            </div>

            <div className="display-ebit-numeros__items-ebit-numero">
              <img src={Icon2} alt="Icone Check" />
              <p className="numero-ebit">720 mil</p>
              <p className="info-numeros-ebit">pedidos registrados por dia em média</p>
              <small className="form-text text-muted"><i>Média de Janeiro a Maio de 2020</i></small>
            </div>

            <div className="display-ebit-numeros__items-ebit-numero">
              <img src={Icon3} alt="Icone Carrinho de compra" />
              <p className="numero-ebit">1 milhão</p>
              <p className="info-numeros-ebit">de itens recebidos por dia</p>
              <small className="form-text text-muted"><i>Aproximadamente</i></small>
            </div>
          </div>
        </div>
      </div>
      <StepSurvey />
      <MedalLink />
      <div className="time-line-ebit container-fluid">
        <div className="container">
          <h2>Nossa Trajetória</h2>
          <div className="lt-responsive">
            <img src={LTempo} alt="Linha do tempo Ebit" />
          </div>
          <div  className="lt-responsive01">
            <img src={LTempoV} alt="Linha do tempo Ebit" />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

export default SobreNos;